// extracted by mini-css-extract-plugin
export default {"container":"ButtonPill_container__4CMke","secondary":"ButtonPill_secondary__EZGas","primary":"ButtonPill_primary__C010E"};